import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchWithAuth } from '../../utils/ApiTools'

const initialState = {
  userCollection: [],
  userResource: null,
  vendorCollection: [],
  userSaved: false,
  technicians: [],
  userList: [],
  loading: false,
  pageCount: 0,
  totalItems: 0,
  pageIndex: 0,
  pageSize: 25,
  user_types: [],
  roles: [],
  statuses: [],
  success: false
};

const errorHandler = (error) => {
  return error.response?.data?.message || error.message || 'Something went wrong';
}

export const fetchUsers = createAsyncThunk('users/all',
    async ({
      user_type,
      role,
      status,
      companyId,
      page = 1,
      per = 25,
      search = '',
      sorting = [],
      navigate
    }) => {

  const msoId = localStorage.getItem('msoId');
  let queryParams = new URLSearchParams({
    page: page,
    per: per,
  });

  if (search) queryParams.append('search', search);
  if (companyId) queryParams.append('company_id', companyId);

  let sortBy = '';
  let direction = '';
  const sortField = sorting.find(s => s.selected);

  sortBy = sortField ? sortField.id : 'id';
  direction = sortField ? (sortField.desc ? 'desc' : 'asc') : 'asc';

  if (sortBy) {
    queryParams.append('sort_by', sortBy);
    queryParams.append('direction', direction);
  }

  if (user_type) {
    queryParams.append('user_type', user_type);
  }
  if (role) {
    queryParams.append('role', role);
  }
  if (status) {
    queryParams.append('status', status);
  }

  const url = `${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users?${queryParams.toString()}`

  return fetchWithAuth(url, {}, navigate);
});


  export const fetchUserListByCompany = createAsyncThunk('users/list',
    async ({ companyId, page = 1, per = 9999, navigate }, { rejectWithValue }) => {

    const msoId = localStorage.getItem('msoId');
    let queryParams = new URLSearchParams();

    // if (companyId) {
    //   queryParams.append('company_id', companyId);
    // }

    // if (areaId) {
    //   queryParams.append('area_id', areaId);
    // }

    try {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/companies/${companyId}/users/list?${queryParams.toString()}`
      const response = await fetchWithAuth(url, {}, navigate);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  });

export const fetchUser = createAsyncThunk(
  'user/fetchUser',
  async (userId, { rejectWithValue }) => {
    const msoId = localStorage.getItem('msoId');
    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchUserTechids = createAsyncThunk(
  'user/fetchUserTechids',
  async (userId, { rejectWithValue }) => {
    const msoId = localStorage.getItem('msoId');
    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users/${userId}/technician_list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchUserEnums = createAsyncThunk(
  'user/fetchUserEnums',
  async () => {
    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/v1/users/user_enums`);

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const fetchVendors = createAsyncThunk(
  'user/fetchVendors',
  async () => {
    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/v1/vendors`);

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const editUser = createAsyncThunk(
  'user/editUser',
  async ({ userId, formData, navigate }, { rejectWithValue }) => {
    const msoId = localStorage.getItem('msoId');
    try {
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users/${userId}`,
        {
          method: 'PUT',
          body: JSON.stringify({ user: formData }),
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const addUser = createAsyncThunk(
  'user/addUser',
  async (formData, { rejectWithValue }) => {
    const msoId = localStorage.getItem('msoId');
    try {
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users`,
        {
          method: 'POST',
          body: JSON.stringify({ user: formData }),
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const addTechnician = createAsyncThunk(
  'user/addTechnician',
  async ({ userId, techData }, { rejectWithValue }) => {
    const msoId = localStorage.getItem('msoId');


    try {
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}/api/v1/msos/${msoId}/users/${userId}/create_tech_association`,
        {
          method: 'POST',
          body: JSON.stringify({ user: techData }),
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);


const usersSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUsers: () => {
      return initialState;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    setSelectedCompanyId: (state, action) => {
      state.selectedCompanyId = action.payload;
    },
    setSelectedAreaId: (state, action) => {
      state.selectedAreaId = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUserSaved: (state, action) => {
      state.userSaved = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state, action) => {
      state.loading = true;
    })
    .addCase(fetchUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.userCollection = action.payload.data;
      state.pageCount = action.payload.meta.pagination.total_pages;
      state.totalItems = action.payload.meta.pagination.total_items;
      state.error = null;
    })
    .addCase(fetchUsers.rejected, (state, action) => {
      state.loading = false;
      state.userCollection = [];
      state.error = action.error.message;
    })
    .addCase(fetchUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchUser.fulfilled, (state, action) => {
      state.loading = false;
      state.userResource = action.payload;
    })
    .addCase(fetchUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(fetchUserListByCompany.pending, (state, action) => {
      state.loading = true;
      state.userList = [];
    })
    .addCase(fetchUserListByCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.userList = action.payload;
      state.error = null;
    })
    .addCase(fetchUserListByCompany.rejected, (state, action) => {
      state.loading = false;
      state.userList = [];
      state.error = action.error.message;
    })

    .addCase(fetchUserTechids.pending, (state, action) => {
      state.loading = true;
      state.technicians = [];
    })
    .addCase(fetchUserTechids.fulfilled, (state, action) => {
      state.loading = false;
      state.technicians = action.payload;
      state.error = null;
    })
    .addCase(fetchUserTechids.rejected, (state, action) => {
      state.loading = false;
      state.technicians = [];
      state.error = action.error.message;
    })

    .addCase(editUser.pending, (state) => {
      state.userSaved = false;
      state.loading = true;
      state.success = false
      state.error = null;
    })
    .addCase(editUser.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.userSaved = true;
      state.userResource = action.payload;
    })
    .addCase(editUser.rejected, (state, action) => {
      state.userSaved = false;
      state.loading = false;
      state.success = false
      state.error = action.payload;
    })
    .addCase(addUser.pending, (state) => {
      state.userSaved = false;
      state.loading = true;
      state.success = false;
      state.error = null;
    })
    .addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.userSaved = true;
      state.userResource = action.payload;
      state.userCollection.push(action.payload)
    })
    .addCase(addUser.rejected, (state, action) => {
      state.userSaved = false;
      state.loading = false;
      state.success = false
      state.error = action.payload;
    })

    .addCase(addTechnician.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    })
    .addCase(addTechnician.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      //state.technicians.push(action.payload)
    })
    .addCase(addTechnician.rejected, (state, action) => {
      state.loading = false;
      state.success = false
      state.error = action.payload;
    })

    .addCase(fetchVendors.pending, (state, action) => {
      state.success = false
      state.loading = true;
    })
    .addCase(fetchVendors.fulfilled, (state, action) => {
      state.loading = false;
      state.vendorCollection = action.payload;
      state.error = null;
    })
    .addCase(fetchVendors.rejected, (state, action) => {
      state.loading = false;
      state.vendorCollection = [];
      state.error = action.error.message;
    })
    .addCase(fetchUserEnums.pending, (state, action) => {
      state.success = false
      state.loading = true;
    })
    .addCase(fetchUserEnums.fulfilled, (state, action) => {
      state.loading = false;
      state.user_types = action.payload.user_types;
      state.roles = action.payload.roles;
      state.statuses = action.payload.statuses;
      state.error = null;
    })
    .addCase(fetchUserEnums.rejected, (state, action) => {
      state.loading = false;
      state.enums = {};
      state.error = action.error.message;
    });
}
});

export const {
  clearUsers,
  clearFormData,
  setPageSize,
  setSelectedCompanyId,
  setSelectedAreaId,
  setSuccess,
  setPageIndex,
  setError,
  setUserSaved
} = usersSlice.actions;
export default usersSlice.reducer;